import { css } from '@emotion/react';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';
import { wplToken } from '@atlassiansox/wpl-token';

const productFontStyle = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 1.125rem;
`;

const appLineStyle = css`
  content: '';
  position: absolute;
  top: 2.5rem;
  left: 0;
  width: 1.5625rem;
  height: 0rem;
  border-top: 0.0625rem solid ${getColor('n50')};
  ${getMediaDown('md')} {
    top: 2.25rem;
  }
`;

export const appWrapperContainer = css`
  display: flex;
  justify-content: space-between;
  align-self: flex-start;
  align-items: flex-start;
  width: 100%;
  border-left: 0.0625rem solid ${getColor('n50')};
  ${getMediaDown('md')} {
    align-items: start;
    flex-direction: column;
  }
`;

export const appContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${productFontStyle};
  position: relative;
  padding-top: ${wplToken('space.100')};
  padding-left: ${wplToken('space.400')};
  ::before {
    ${appLineStyle}
  }
  ${getMediaDown('md')} {
    padding-top: 0;
  }
`;

export const appPricingContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-top: 38px;

  ${getMediaDown('md')} {
    align-items: start;
    position: static;
    margin-top: 30px;
    margin-left: 1.875rem;
  }
`;

export const appLogoNameContainer = css`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
  > div {
    display: flex;
    &:first-of-type {
      flex-shrink: 0;
    }
    &:last-child {
      flex-shrink: 1;
      word-break: break-word;
    }
  }
  ${getMediaDown('md')} {
    align-items: flex-start;
    flex-direction: row;
    overflow-wrap: break-word;
    &:first-of-type {
      padding-top: ${wplToken('space.050')};
    }
  }
`;

export const appIconStyle = css`
  display: flex;
  margin-top: ${wplToken('space.250')};
  margin-right: 0.25rem;
  flex-shrink: 0;
`;

export const appNameStyle = css`
  max-width: 27.0625rem;
  word-break: break-word;
  margin-top: ${wplToken('space.250')};
  line-height: normal;
`;

export const appDisclaimerStyle = css`
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  font-family: var(--bxp-charlie-text-font-family);
  line-height: normal;
  color: ${getColor('n800')};
  margin-left: 1.875rem;
  margin-top: 1rem;
`;

export const highestUnitCountDisclaimerStyle = css`
  padding-left: 16px;
`;

export const errorMessageStyle = css`
  color: red;
  font-size: 0.75rem;
  max-width: 27.0625rem;
  line-height: 16px;
`;
